import { css } from '@emotion/css';

export const styToggleExpander = css`
  margin: -6px;
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
  display: flex;
`;
